module.exports = __webpack_public_path__ + "static/media/d86863bd-a6e3-4cd0-abe7-a711edaaebc6.1ed2f929.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/d86863bd-a6e3-4cd0-abe7-a711edaaebc6.ttf
// module id = 101
// module chunks = 0